module.exports = __webpack_public_path__ + "fonts/Manrope-600-vietnamese16_c4999d3.woff2";